import { capitalize } from 'lodash'
import React from 'react'
import { Helmet } from 'react-helmet'
import { Route, Switch } from 'react-router'
import SearchOptionsManager from 'shared/components/context/search-options-manager'
import { SearchOptionsPageData } from 'shared/types/page-data'
import { removeWords } from 'shared/util/string'
import Favorites from '../containers/favorites'
import SearchResults from './search'

type Props = {
    search: SearchOptionsPageData
    groupId: string
    pageType: string
    showTV: boolean
}
const SearchRoute = (props: Props) => {
    const IMAGE_TYPES = ['gif', 'gifs', 'sticker', 'stickers']
    const { groupId, search } = props
    let title

    if (groupId === 'favorites') {
        title = `Search, Discover, Share, and Create Animated GIFs | GIPHY`
    } else if (search) {
        if (props.pageType === 'EXPLORE') {
            title = `${capitalize(removeWords(search.term, IMAGE_TYPES))} GIFs - Get the best GIF on GIPHY`
        } else {
            title = `${capitalize(removeWords(search.term, IMAGE_TYPES))} ${
                search.isSticker ? 'Stickers' : 'GIFs'
            } - Find & Share on GIPHY`
        }
    }

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <SearchOptionsManager initialSearch={search}>
                <Switch>
                    <Route path={'/search'} render={() => <SearchResults {...props} />} />
                    <Route path={'/explore'} render={() => !search.error && <SearchResults {...props} isExplore />} />
                    <Route path={'/favorites'} component={Favorites} />
                </Switch>
            </SearchOptionsManager>
        </>
    )
}

export default SearchRoute
